import { startChatServer, postMessageServer, getChatsServer, getChatMessagesServer } from '@/actions/chats';
import { getUserAccessToken } from '@/utils/account/getUserAccessToken';

export const startChat = async (tenderId: string, message: string) => {
  const userAccessToken = await getUserAccessToken();
  return startChatServer(tenderId, message, userAccessToken);
};

export const postMessage = async (chatId: string, message: string) => {
  const userAccessToken = await getUserAccessToken();
  return postMessageServer(chatId, message, userAccessToken);
};

export const getChats = async (tenderId: string, organizationId: string) => {
  const userAccessToken = await getUserAccessToken();
  return getChatsServer(tenderId, organizationId, userAccessToken);
};

export const getChatMessages = async (chatId: string) => {
  const userAccessToken = await getUserAccessToken();
  return getChatMessagesServer(chatId, userAccessToken);
};
